import React, { Component } from 'react';
import PropTypes from "prop-types";

class XI extends Component{
    render(){
        const {
            className,
            eleRef,
            onClick,
            attrs,
        } = this.props;

        return(
            <>
                <i className={className} ref={eleRef} onClick={onClick} {...attrs}></i>
            </>
        )
    }
}

XI.propTypes = {
    className: PropTypes.string,
    eleRef: PropTypes.any,
    onClick: PropTypes.func,
    attrs: PropTypes.object,
};

XI.defaultProps = {
    attrs:{}
};

export default  XI;